"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisclaimerArray = exports.getDisclaimer = exports.disclaimerReducer = exports.default = exports.addDisclaimer = exports.DEFAULT_DISCLAIMER = void 0;
exports.getLexusDisclaimer = getLexusDisclaimer;
exports.requestDisclaimer = exports.initialState = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _axios = _interopRequireDefault(require("axios"));
var _graphqlRequest = require("graphql-request");
var _lodashEs = require("lodash-es");
var _createClient = require("../../api/createClient");
var _env = _interopRequireDefault(require("../../utilities/env"));
const qs = require("qs");
const DEFAULT_DISCLAIMER = exports.DEFAULT_DISCLAIMER = {
  code: "default",
  body: "Values are subject to change, conditions may apply."
};
const initialState = exports.initialState = {};
const addDisclaimer = exports.addDisclaimer = (0, _toolkit.createAction)("DISCLAIMER/ADD_DISCLAIMER");
const disclaimerReducer = exports.disclaimerReducer = (0, _toolkit.createReducer)(initialState, {
  [addDisclaimer]: function (state, _ref) {
    let {
      payload = [DEFAULT_DISCLAIMER]
    } = _ref;
    const disclaimers = payload.reduce(function (acc, cur) {
      return {
        ...acc,
        [cur.code]: cur
      };
    }, {});
    return {
      ...state,
      ...disclaimers
    };
  }
});
const getDisclaimerArray = function () {
  let disclaimers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (Array.isArray(disclaimers) ? disclaimers : disclaimers.split(",")).map(function (e) {
    return typeof e === "string" ? e.trim() : e;
  });
};
exports.getDisclaimerArray = getDisclaimerArray;
function getLexusDisclaimer(_ref2) {
  let {
    API,
    code
  } = _ref2;
  return _axios.default.get(API, {
    params: {
      code
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, {
        arrayFormat: "repeat"
      });
    },
    transformResponse: [function (data) {
      return JSON.parse(data) || [];
    }, function (data) {
      return data.map(function (_ref3) {
        let {
          disclaimer,
          ...e
        } = _ref3;
        return {
          body: disclaimer,
          ...e
        };
      });
    }]
  });
}
function createRequest(i) {
  let {
    dealerCd,
    distributorCd,
    modelYear,
    series
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const request = [`disclaimerCode: "${i}"`];
  if (dealerCd) {
    request.push(`dealerCd: "${dealerCd}"`);
  }
  if (distributorCd) {
    request.push(`distributorCd: "${distributorCd}"`);
  }
  if (modelYear) {
    request.push(`modelYear: ${modelYear}`);
  }
  if (series) {
    request.push(`series: "${series}"`);
  }
  return request;
}
const requestGraphQLDisclaimer = async function (generalClient, code) {
  let data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const client = (0, _createClient.createOwnClient)(generalClient);
  return client.request((0, _graphqlRequest.gql)`
      query {
        getDisclaimers(${createRequest(code, data)}) {
          description
          code
        }
      }
    `);
};
const requestDisclaimer = function (disclaimers, extras, client, enableGraphQLDisclaimers, defaultBody, defaultCode) {
  const code = getDisclaimerArray(disclaimers);
  return async function (dispatch) {
    const API = `${(0, _env.default)("REACT_APP_DISCLAIMERS_API_BASE")}`;
    const apiClient = getLexusDisclaimer;
    if (enableGraphQLDisclaimers && client) {
      const data = await Promise.all(code.map(function (singleCode) {
        return requestGraphQLDisclaimer(client, singleCode, extras);
      }));
      const disclaimers = data.map(function (disclaimer) {
        var _disclaimer$getDiscla, _disclaimer$getDiscla2;
        return {
          body: (disclaimer === null || disclaimer === void 0 ? void 0 : (_disclaimer$getDiscla = disclaimer.getDisclaimers) === null || _disclaimer$getDiscla === void 0 ? void 0 : _disclaimer$getDiscla.description) || defaultBody || DEFAULT_DISCLAIMER.body,
          code: (disclaimer === null || disclaimer === void 0 ? void 0 : (_disclaimer$getDiscla2 = disclaimer.getDisclaimers) === null || _disclaimer$getDiscla2 === void 0 ? void 0 : _disclaimer$getDiscla2.code) || defaultCode
        };
      });
      dispatch(addDisclaimer(disclaimers.map(function (_ref4) {
        let {
          code,
          body
        } = _ref4;
        return {
          code,
          body
        };
      })));
      return;
    }
    return apiClient({
      API,
      code
    }, extras).then(function (_ref5) {
      let {
        data
      } = _ref5;
      dispatch(addDisclaimer(data.map(function (_ref6) {
        let {
          code,
          body
        } = _ref6;
        return {
          code,
          body
        };
      })));
    }).catch(function (e) {
      dispatch(addDisclaimer(code.map(function (c) {
        return {
          code: c,
          body: DEFAULT_DISCLAIMER.body
        };
      })));
    });
  };
};
exports.requestDisclaimer = requestDisclaimer;
const getDisclaimer = function () {
  let codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lodashEs.memoize)(function (disclaimers) {
    const lookup = codes.map(function (e) {
      const map = disclaimers[e];
      if (!map) {
        return undefined;
      }
      return map;
    }).filter(function (e) {
      return typeof e !== "undefined";
    });
    return codes.length - lookup.length === 0 ? lookup : undefined;
  });
};
exports.getDisclaimer = getDisclaimer;
var _default = exports.default = disclaimerReducer;